const EDD_API_URL = 'https://5gg66a38lj.execute-api.ap-south-1.amazonaws.com/prod/edd';
// TODO: replace REVERSE_GEO_URL with production URL — currently pointing to UAT environment
const REVERSE_GEO_URL = 'https://dotconnectuat.dotandkey.com/api/v1/edd/reverse';
const POSTAL_API_URL = 'https://api.postalpincode.in/pincode/';

const EDD_PIN_STATE_MAP = [
  { start: 110000, end: 119999, capital: 'Delhi' },
  { start: 120000, end: 129999, capital: 'Chandigarh' },
  { start: 130000, end: 169999, capital: 'Chandigarh' },
  { start: 170000, end: 199999, capital: 'Shimla' },
  { start: 200000, end: 269999, capital: 'Lucknow' },
  { start: 300000, end: 349999, capital: 'Jaipur' },
  { start: 350000, end: 399999, capital: 'Gandhinagar' },
  { start: 400000, end: 449999, capital: 'Mumbai' },
  { start: 450000, end: 489999, capital: 'Bhopal' },
  { start: 500000, end: 539999, capital: 'Hyderabad' },
  { start: 540000, end: 599999, capital: 'Bengaluru' },
  { start: 600000, end: 649999, capital: 'Chennai' },
  { start: 650000, end: 689999, capital: 'Thiruvananthapuram' },
  { start: 700000, end: 749999, capital: 'Kolkata' },
  { start: 750000, end: 799999, capital: 'Bhubaneswar' },
  { start: 800000, end: 849999, capital: 'Patna' },
  { start: 850000, end: 889999, capital: 'Ranchi' },
  { start: 900000, end: 999999, capital: 'Dispur' },
];

const formatDayMonth = (dateStr) => {
  const date = new Date(dateStr);
  return `${date.getDate()} ${date.toLocaleString('en-US', { month: 'long' })}`;
};

// type: 'success' | 'error' | 'loading' | null (neutral/reset)
const setEddInfo = (infoEl, message, type) => {
  infoEl.textContent = message;
  infoEl.classList.remove(
    'main-pdp-edd__info--success',
    'main-pdp-edd__info--error',
    'main-pdp-edd__info--loading'
  );
  if (type) infoEl.classList.add(`main-pdp-edd__info--${type}`);
};

const fetchPincodeDetails = async (pincode) => {
  try {
    const res = await fetch(`${POSTAL_API_URL}${pincode}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    if (data[0].Status === 'Success' && data[0].PostOffice?.length > 0) {
      const { State: state, Pincode: pin, District: district } = data[0].PostOffice[0];
      return { state, pin, district };
    }
    const pinNum = Number(pincode);
    const entry = EDD_PIN_STATE_MAP.find(({ start, end }) => pinNum >= start && pinNum <= end);
    return entry ? { state: entry.capital, pin: pincode, district: null } : null;
  } catch {
    return null;
  }
};

// Caches the last successful lookup so re-checking the same pincode for the
// same variant never depends on a second, potentially flaky network round trip.
let lastEddSuccess = null;

const applyEddSuccess = (message, tempStorePin) => {
  document.querySelectorAll('[data-edd-container]').forEach((container) => {
    const infoEl = container.querySelector('[data-edd-info]');
    const tempStore = container.querySelector('[data-edd-temp-store]');
    const submitBtn = container.querySelector('[data-edd-submit]');
    if (infoEl) setEddInfo(infoEl, message, 'success');
    if (tempStore) tempStore.value = tempStorePin ?? '';
    if (submitBtn) submitBtn.textContent = 'Change';
  });
};

const fetchAndUpdateAll = async (customerPincode, skuCode) => {
  if (lastEddSuccess && lastEddSuccess.pincode === customerPincode && lastEddSuccess.skuCode === skuCode) {
    applyEddSuccess(lastEddSuccess.message, lastEddSuccess.tempStorePin);
    return;
  }

  const params = new URLSearchParams({ customerPincode, skuCode });
  try {
    const res = await fetch(`${EDD_API_URL}?${params.toString()}`, { method: 'GET', mode: 'cors' });
    if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
    const data = await res.json();

    if (data.edd && data.sla_days && data.drop_pincode) {
      const estimatedDayMonth = formatDayMonth(data.edd);
      const addressDetails = await fetchPincodeDetails(customerPincode);
      const message = `Estimated Delivery by ${estimatedDayMonth}`;

      lastEddSuccess = { pincode: customerPincode, skuCode, message, tempStorePin: addressDetails?.pin ?? '' };
      applyEddSuccess(message, lastEddSuccess.tempStorePin);
    } else {
      throw new Error('Missing edd/sla_days/drop_pincode in response');
    }
  } catch {
    document.querySelectorAll('[data-edd-container]').forEach((container) => {
      const infoEl = container.querySelector('[data-edd-info]');
      const inputEl = container.querySelector('[data-edd-input]');
      const submitBtn = container.querySelector('[data-edd-submit]');
      if (infoEl) setEddInfo(infoEl, 'Unable to check delivery for this pincode. Please try again.', 'error');
      if (inputEl) inputEl.value = '';
      if (submitBtn) submitBtn.textContent = 'Check';
    });
  }
};

// Sync SKU hidden inputs on variant change
if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ variant }) => {
    if (!variant?.sku) return;
    document.querySelectorAll('[data-edd-sku]').forEach((el) => { el.value = variant.sku; });
  });
}

// Per-container button click handler
document.querySelectorAll('[data-edd-container]').forEach((container) => {
  const submitBtn = container.querySelector('[data-edd-submit]');
  if (!submitBtn) return;

  submitBtn.addEventListener('click', () => {
    const infoEl = container.querySelector('[data-edd-info]');
    const pincodeInput = container.querySelector('[data-edd-input]');
    const skuValue = container.querySelector('[data-edd-sku]')?.value?.trim() ?? '';

    if (!infoEl || !pincodeInput) return;

    const btnText = submitBtn.textContent.trim();

    if (btnText === 'Check') {
      const pincode = pincodeInput.value.trim();
      if (!pincode) {
        setEddInfo(infoEl, 'Please enter a pincode.', 'error');
        return;
      }
      if (!/^\d{6}$/.test(pincode)) {
        setEddInfo(infoEl, 'Please enter a valid 6-digit pincode.', 'error');
        return;
      }
      if (!skuValue) {
        setEddInfo(infoEl, 'Something went wrong. Please refresh the page and try again.', 'error');
        return;
      }

      setEddInfo(infoEl, 'Checking delivery date…', 'loading');
      submitBtn.disabled = true;
      fetchAndUpdateAll(pincode, skuValue).finally(() => {
        submitBtn.disabled = false;
      });

    } else if (btnText === 'Change') {
      document.querySelectorAll('[data-edd-container]').forEach((c) => {
        const inp = c.querySelector('[data-edd-input]');
        const inf = c.querySelector('[data-edd-info]');
        const btn = c.querySelector('[data-edd-submit]');
        if (inp) { inp.value = ''; inp.placeholder = 'Enter your pincode'; }
        if (inf) setEddInfo(inf, '', null);
        if (btn) btn.textContent = 'Check';
      });
    }
  });

  // Enter key triggers check
  const pincodeInput = container.querySelector('[data-edd-input]');
  pincodeInput?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && submitBtn.textContent.trim() === 'Check') submitBtn.click();
  });

  // Digits only
  pincodeInput?.addEventListener('input', () => {
    pincodeInput.value = pincodeInput.value.replace(/\D/g, '');
  });
});
